module.exports = __webpack_public_path__ + "img/sweden-liver-cancer-male.d2a7333c.png";